
<div>
  {{ message}}
</div>


<div class="p-dialog-footer">

  <p-button label="Sí" (click)="returnYes()"></p-button>
  <p-button label="No" (click)="returnNo()"></p-button>

</div>